// extracted by mini-css-extract-plugin
export default {"customRadioButton":"styles_customRadioButton__NtjbR","ant-radio":"styles_ant-radio__AJEkc","ant-radio-checked":"styles_ant-radio-checked__F7DiW","radioBox":"styles_radioBox__BC9XO"};